var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.chips),function(chip){return _c('div',{staticClass:"chip"},[_c('span',[_vm._v(_vm._s(chip))]),_vm._v(" "),_c('button',{attrs:{"type":"button","title":"Remove chip","arial-label":"Remove chip"},on:{"click":function($event){return _vm.onRemoveChip(chip)}}},[_c('span',{staticClass:"icon-close"})])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9156d7f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/components/chip.vue
// module id = null
// module chunks = 